import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useMemo, useState, useCallback } from 'react';

import { Grid, IconButton } from '@mui/material';
import { DateInput } from '../../../../../components/dateInput/DateInput';
import moment from 'moment';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import GET_CONEXIONES_CONTRATO, { adaptConexionesArray } from '../../../../../data/graphQL/queries/GestionAsistencial/allConexionesContrato';
import { DELETE_CONEXION } from '../../../../../data/graphQL/mutations/GestionAsistencial/deleteConexion';
import { CREATE_CONEXION } from '../../../../../data/graphQL/mutations/GestionAsistencial/createConexion';
import { CREATE_CONEXION_MULTIPLE } from '../../../../../data/graphQL/mutations/GestionAsistencial/createConexionMultiple';

const DeleteButton = ({ idConexion, deleteConexion, estado, allowedWrite, fechaConexion }) => {
  const fechaLimite = moment(fechaConexion).add(1, "month").startOf("month").add(9, "days");
  const hoy = moment();
  const handleDelete = useCallback(() => {
    if (estado.trim() == 'PE' || estado.trim() == 'AT') {
      if (hoy.isSameOrBefore(fechaLimite)) {
        deleteConexion({
          variables: { idConexion },
          onError: (error) => {
            toast.error(`Error eliminando la conexión: ${error.message}`);
          }
        });
      } else

      toast.error('No se puede eliminar la conexión. Se ha superado el plazo de días');
    } else

    toast.error('No se puede eliminar la conexión. Estado no permitido');
  }, [idConexion, deleteConexion, estado, fechaConexion]);

  return (
    <IconButton onClick={handleDelete} disabled={!allowedWrite}>
            <DeleteOutlineIcon className='default-icon' />
        </IconButton>);

};

export const Conexiones = ({
  idPaciente,
  allowedWrite,
  idEvaluacionSelected,
  esquema,
  poseeEsquema,
  dias,
  getContratos,
  estadoAsistencial,
  suspensiones,
  evaluacionSelected
}) => {

  const [fechaConexion, setFechaConexion] = useState(moment().format('yyyy-MM-DD HH:mm:ss'));

  const [rangoFecha, setRangoFecha] = useState({
    fechaDesde: moment().format('yyyy-MM-DD HH:mm:ss'),
    fechaHasta: moment().format('yyyy-MM-DD HH:mm:ss')
  });

  const {
    columns,
    rows,
    totalCount,
    getConexiones
  } = useGetConexiones(idPaciente, idEvaluacionSelected, allowedWrite);

  const handleChangeRangoFechaConexion = (name, value) => {
    setRangoFecha((prev) => ({
      ...prev,
      [name]: moment(value).format('yyyy-MM-DD HH:mm:ss')
    }));
  };

  const handleChangeFechaConexion = (value) => {
    const formattedValue = moment(value).format('yyyy-MM-DD HH:mm:ss');
    const selectedDayOfWeek = moment(value).day() + 1; // 0 (Domingo) a 7 (Sábado) + 1 

    if (!poseeEsquema) {
      setFechaConexion(formattedValue);
    } else {
      const isValidDay = esquema?.some((diaId) => diaId === selectedDayOfWeek);

      if (isValidDay || !evaluacionSelected.planCuidadoPoseeEsquema) {
        setFechaConexion(formattedValue);
      } else {
        toast.error("La fecha seleccionada no corresponde con los días del esquema");
      }
    }
  };

  const [createConexion] = useMutation(CREATE_CONEXION, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.createConexion?.success) {
        toast.success("Se creó la conexión correctamente");
        getConexiones({variables: {
          idPaciente,
          idEvaluacion: idEvaluacionSelected
        }});
        getContratos({variables: { idPaciente }});
      } else

      toast.error(data.createConexion?.error);
    }
  });

  const onAddConexion = () => {
    const isWithinSuspension = suspensiones.some((suspension) => {
      const suspensionFechaDesde = moment(suspension.fechaDesde).startOf('day');
      const suspensionFechaHasta = moment(suspension.fechaHasta).endOf('day');

      const fechaConexionMoment = moment(fechaConexion).startOf('day');

      return fechaConexionMoment.isBetween(suspensionFechaDesde, suspensionFechaHasta, null, '[]');
    });
    const errorMessages = [];

    if (isWithinSuspension)
    errorMessages.push("No es posible crear conexiones debido a que el estado asistencial se encuentra suspendido.");
    if (evaluacionSelected.planCuidadoPoseeEsquema && !poseeEsquema)
    errorMessages.push("El plan de cuidado vinculado exige un esquema de conexión obligatorio.");

    if (errorMessages.length > 0)
    toast.error(errorMessages.join("\n"));else
    {
      createConexion({
        variables: {
          idEvaluacion: idEvaluacionSelected,
          fechaConexion: fechaConexion
        }
      });
    }
  };

  const [createConexionMultiple] = useMutation(CREATE_CONEXION_MULTIPLE, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.createConexionMultiple?.success) {
        toast.success("Se crearon las conexiones correctamente");
        getConexiones({variables: {
          idPaciente,
          idEvaluacion: idEvaluacionSelected
        }});
        getContratos({variables: { idPaciente }});
      } else

      toast.error(data.createConexionMultiple?.error);
    }
  });

  const onAddMultiplesConexiones = () => {
    const isWithinSuspension = suspensiones.some((suspension) => {
      const suspensionFechaDesde = moment(suspension.fechaDesde).startOf('day');
      const suspensionFechaHasta = moment(suspension.fechaHasta).endOf('day');

      const rangoFechaDesde = moment(rangoFecha.fechaDesde).startOf('day');
      const rangoFechaHasta = moment(rangoFecha.fechaHasta).endOf('day');

      return (
        rangoFechaDesde.isBetween(suspensionFechaDesde, suspensionFechaHasta, null, '[]') ||
        rangoFechaHasta.isBetween(suspensionFechaDesde, suspensionFechaHasta, null, '[]') ||
        rangoFechaDesde.isSameOrBefore(suspensionFechaDesde) && rangoFechaHasta.isSameOrAfter(suspensionFechaHasta));

    });
    const errorMessages = [];

    if (isWithinSuspension)
    errorMessages.push("No es posible crear conexiones debido a que el estado asistencial se encuentra suspendido.");
    if (evaluacionSelected.planCuidadoPoseeEsquema && !poseeEsquema)
    errorMessages.push("El plan de cuidado vinculado exige un esquema de conexión obligatorio.");

    if (errorMessages.length > 0)
    toast.error(errorMessages.join("\n"));else
    {
      createConexionMultiple({
        variables: {
          idEvaluacion: idEvaluacionSelected,
          fechaDesde: moment(rangoFecha.fechaDesde).format('YYYY-MM-DD'),
          fechaHasta: moment(rangoFecha.fechaHasta).format('YYYY-MM-DD')
        }
      });
    }
  };

  return (
    <div className='generic-tab-container container-separate'>
            <Grid container spacing={3}>
                <Grid size={{ xs: 12 }}>
                    <div className='generic-header-tab-content-with-buttons'>
                        <strong>Conexiones</strong>
                    </div>
                </Grid>
                <Grid container spacing={1} size={{ xs: 12 }}>
                    <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
                        <DateInput
              label="F. conexión"
              value={fechaConexion}
              onChange={(value) => handleChangeFechaConexion(value)}
              disabled={!allowedWrite} />
            
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
                        <CustomButton
              label='Agregar conexión'
              variant='outlined'
              onClick={onAddConexion}
              disabled={!allowedWrite} />
            
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
                        <DateInput
              label="F. desde conexión"
              value={rangoFecha.fechaDesde}
              onChange={(value) => handleChangeRangoFechaConexion('fechaDesde', value)}
              disabled={!allowedWrite} />
            
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, lg: 2 }}>
                        <DateInput
              label="F. hasta conexión"
              value={rangoFecha.fechaHasta}
              onChange={(value) => handleChangeRangoFechaConexion('fechaHasta', value)}
              disabled={!allowedWrite} />
            
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
                        <CustomButton
              label='Agregar multiples conexiones'
              variant='outlined'
              onClick={onAddMultiplesConexiones}
              disabled={!allowedWrite} />
            
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <DataGridGenerico
                      toolbar={false}
                      columns={columns}
                      rows={rows}
                      totalCount={totalCount} />          
                </Grid>
            </Grid>
        </div>);

};

const useGetConexiones = (idPaciente, idEvaluacion, allowedWrite) => {

  const [rows, setRows] = useState([]);

  const [getConexiones, { data: dataConexiones }] = useLazyQuery(GET_CONEXIONES_CONTRATO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataConexiones) return;
    setRows(adaptConexionesArray(dataConexiones?.allConexionesContrato));
  }, [dataConexiones]);


  const [deleteConexion] = useMutation(DELETE_CONEXION, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (!data?.removeConexion) {
        toast.error("No se puede eliminar la última conexion del mes, porque el contrato ya tiene dos envios.");
      } else
      {
        toast.success("Se eliminó la conexión correctamente");
        getConexiones({variables: {
          idPaciente,
          idEvaluacion
        }});
      }
    }
  });

  const baseColumns = [
  {
    headerName: '',
    field: 'action',
    flex: 1,
    renderCell: ({ row }) =>
    <DeleteButton
      idConexion={row.idConexion}
      deleteConexion={deleteConexion}
      estado={row.estado}
      allowedWrite={allowedWrite}
      fechaConexion={row.fechaConexion} />


  },
  {
    headerName: 'Id Conexión',
    field: 'idConexion',
    flex: 2
  },
  {
    headerName: 'Id Paciente',
    field: 'idPaciente',
    flex: 1.5,
    valueGetter: () => idPaciente
  },
  {
    headerName: 'Id Evaluacion',
    field: 'idEvaluacion',
    flex: 1.5
  },
  {
    headerName: 'Estado',
    field: 'estado',
    flex: 1.5
  },
  {
    headerName: 'Usuario',
    field: 'usuario',
    flex: 1.5
  },
  {
    headerName: 'Fecha Conexión',
    field: 'fechaConexion',
    type: 'date',
    flex: 1.5
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(baseColumns), [baseColumns]);
  const totalCount = useMemo(() => rows?.length || 0, [rows]);

  useEffect(() => {
    if (!idPaciente || !idEvaluacion) return;
    getConexiones({variables: {
          idPaciente,
          idEvaluacion
        }});
  }, [idPaciente, idEvaluacion]);

  return {
    columns,
    rows,
    totalCount,
    getConexiones
  };
};